import Vue from 'vue';
import injector from 'vue-inject';

Vue.use(injector);

let api   = injector.get('api'),
    money = injector.get('money'),
    popup = injector.get('popup');

class Transfer {
    process(type, amount) {
        switch(type) {
            case 'mining':
                return this.miningTransfer(amount);
            case 'royal':
                return this.royalTransfer(amount);
        }
    }

    royalTransfer(amount) {
        return Vue.http.post(api.transfer.royalTransfer, { amount: money.unformat(amount, 'fto') }).then(() => {
            popup.show('Transfer completed successfully.', 'OK', true);
        }, (error) => {
            popup.show(error.data.errors[0].message, 'OK', true);
        })
    }

    miningTransfer(amount) {
        return Vue.http.post(api.transfer.miningTransfer, { amount: money.unformat(amount, 'fto') }).then(() => {
            popup.show('Transfer completed successfully.', 'OK', true);
        }, (error) => {
            popup.show(error.data.errors[0].message, 'OK', true);
        });
    }
}

injector.service('transfer', Transfer);



// WEBPACK FOOTER //
// ./src/services/transfer.js